const profileData = {
  userName: "Bairminer",
  photoLink: "https://i.imgur.com/c16rgFI.png",
  desc: "taking over the world",
};

const themeData = {
  light: {
    backgroundColor: "white",
    onHoverBackgroundColor: "#dfe6e9",
    cardBackgroundColor: "#ffffff",
    onHoverTextColor: "#636e72",
    footerColor: "black",
    footerSocialLinkColor: "white",
    headerFontColor: "#black",
    CardtextColor: "#2d3436",
  },
  dark: {
    backgroundColor: "#181a1f",
    onHoverBackgroundColor: "#1b1e28",
    cardBackgroundColor: "#282c34",
    onHoverTextColor: "white",
    footerColor: "white",
    footerSocialLinkColor: "white",
    headerFontColor: "white",
    CardtextColor: "white",
  },
};
const linkData = [
  {
    id: 1,
    link: "https://steamcommunity.com/id/bairminer/",
    name: "Steam",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/c/c1/Steam_Logo.png",
  },
  {
    id: 2,
    link: "https://www.youtube.com/@bairminer",
    name: "Youtube",
    image: 
      "https://upload.wikimedia.org/wikipedia/commons/4/4a/Youtube-.png",
  },
  {
    id: 3,
    link: "https://open.spotify.com/user/bairminer",
    name: "Spotify",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/9/9b/Spotify_1.png",
  },
  {
    id: 4,
    link: "https://www.reddit.com/user/Bairminer",
    name: "Reddit",
    image:
      "https://redditinc.com/hs-fs/hubfs/Reddit%20Inc/Content/Brand%20Page/Reddit_Logo.png?width=600&height=600&name=Reddit_Logo.png",
  },
  {
    id: 5,
    link: "https://twitter.com/Bairminer",
    name: "X, formerly known as Twitter",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/2/2d/Twitter_X.png",
  },
  {
    id: 6,
    link: "https://www.instagram.com/bairminer/",
    name: "Instagram",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/5/58/Instagram-Icon.png",
  },
  {
    id: 7,
    link: "https://www.twitch.tv/bairminer",
    name: "Twitch",
    image:
      "https://w7.pngwing.com/pngs/968/223/png-transparent-logo-twitch-logos-brands-icon.png",
  },
  {
    id: 8,
    link: "https://pin.it/30hsMYm",
    name: "Pinterest",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/0/08/Pinterest-logo.png",
  },
  {
    id: 9,
    link: "https://imgur.com/user/Bairminer/submitted",
    name: "Imgur",
    image:
      "https://i.imgur.com/KREIQHJ.png",
  },
  {
    id: 10,
    link: "https://www.tumblr.com/bairminer",
    name: "Tumblr",
    image:
      "https://static.wikia.nocookie.net/logopedia/images/8/88/TumblrIcon.jpg/",
  },
];

const footerData = {
  text: "△ ☽ α",
};

const quotes = [
  "\"Some people, I'd fight the world for.\"",
  "\"We make our own luck.\"",
  "\"Good luck. Don't fail.\"",
  "\"Sweat memes, sweet dreams.\"",
  "\"Never stop.\"",
  "\"It's cute and fuzzy!\"",
  "\"Frick\"",
  "\"I need a new pfp\"",
];

const songs = [
  "https://open.spotify.com/embed/track/0tBbt8CrmxbjRP0pueQkyU?utm_source=generator",
  "https://open.spotify.com/embed/track/1vn7Y9dR0e6i58R71yccG9?utm_source=generator",
  "https://open.spotify.com/embed/track/3VvBPkc24zC7x05mgJTyGO?utm_source=generator",
  "https://open.spotify.com/embed/track/7MXVkk9YMctZqd1Srtv4MB?utm_source=generator",
  "https://open.spotify.com/embed/track/2K87XMYnUMqLcX3zvtAF4G?utm_source=generator",
  "https://open.spotify.com/embed/track/40riOy7x9W7GXjyGp4pjAv?utm_source=generator",
]


export { profileData, linkData, themeData, footerData, quotes, songs };
